export const colors = {
  main: '#D40132',
  secondary: '#fff',
  other: '#aaa',
  back: 'grey',
  red: '#D40132',
  black: '#000000',
  facebook: '#3567b1',
  twitter: '#d42d2f',
  instagram: '#ec5970'
}

export const fonts = {
  font: 'Montserrat',
  bold: '700',
  semibold: '600',
  regular: '400',
  light: '300'
}

export const align = {
  center: 'center',
  left: 'left',
  right: 'right'
}

export const lang = {
  title_vm: 'Le titre 2'
}